export default __webpack_public_path__ + "static/syncthink-e76661a50102a38b1bc15e7436bccc3b.svg";